import { Approbation } from 'src/app/modules/approbations/models/approbation.model';
import { Class } from '../../../classes/models/class.model';
import { EnrollmentPaymentInfo } from '../enrollment-paymentinfo.model';
import { DiscountCode } from 'src/app/modules/discounts/models/discount-code.model';

export class EnrollmentNewRequest {

    editionId    : number;
    studentId    : number;
    knownId      : number;
    paymentInfo  : EnrollmentPaymentInfo;
    classes      : Class[];
    discountCodes: DiscountCode[];
    approbations : Approbation[];

}
